module.exports = __webpack_public_path__ + "img/puzzle_36.b53a13e7.png";